import { required } from 'vuelidate/lib/validators'
import PersonIdent from './PersonIdent'

export default {
  vorname: { required },
  name: { required },
  personIdent: {
    $each: PersonIdent
  }
}



// WEBPACK FOOTER //
// ./src/validation/Person.js